module.exports = __webpack_public_path__ + "img/compassionate-carer.990d954b.svg";